export const DEFAULT_VALUES = 
{
    skip: 0,
    take: 20
}

